import './core.js';
import exclusive from './exclusive.js';
import globalToggle from './globalToggle.js';
import localToggle from './localToggle.js';
import saveState from './saveState.js';

function getPlugins(options) {
  const plugins = [];
  for (const key in options) {
    if (options[key] !== false) {
      switch (key) {
        case 'globalToggle':
          plugins.push(globalToggle);
          break;
        case 'localToggle':
          plugins.push(localToggle);
          break;
        case 'saveState':
          plugins.push(saveState);
          break;
        case 'exclusive':
          plugins.push(exclusive);
          break;
      }
    }
  }
  return plugins;
}

function initAccordion() {
  $('.cmp-accordion[data-cmp-is-loaded="false"]').each(function () {
    const options =
      this.dataset.options !== undefined
        ? JSON.parse(this.dataset.options)
        : {};
    const plugins = getPlugins(options);
    $(this).accordion(options, plugins);
    $(this).attr('data-cmp-is-loaded', 'true');
  });
}

const AccordionComponent = {
  init() {
    initAccordion();

    $('a[href*="#accordionItem"]').on('click', (event) => {
      $(`${event.target.hash}`).attr('open', '');
    });

    const MutationObserver =
      window.MutationObserver ||
      window.WebKitMutationObserver ||
      window.MozMutationObserver;
    const body = document.querySelector('body');
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        // needed for IE
        const nodesArray = [].slice.call(mutation.addedNodes);
        if (nodesArray.length > 0) {
          initAccordion();
        }
      });
    });

    observer.observe(body, {
      subtree: true,
      childList: true,
      characterData: true
    });

    let openAccordion = [];
    window.addEventListener('beforeprint', () => {
      $('.cmp-accordion[data-cmp-is-loaded="true"] details').each(function () {
        if (!this.open) {
          openAccordion.push(this);
        }
        $(this).attr('open', '');
      });
    });

    window.addEventListener('afterprint', () => {
      $(openAccordion).removeAttr('open');
      openAccordion = [];
    });

    window.addEventListener('keydown', (event) => {
      const activeElem = $(document.activeElement);
      if (activeElem.hasClass('cmp-accordion__summary')) {
        switch (event.code) {
          case 'ArrowUp':
            setFocus(activeElem.parent().prev());
            break;
          case 'ArrowDown':
            setFocus(activeElem.parent().next());
            break;
        }

        function setFocus(item) {
          const summary = $('.cmp-accordion__summary', item);
          if (summary.length) {
            summary[0].focus();
          }
        }
      }
    });

    // Add aria-disabled=true in case of Exclusive Accordion
    const accordionExclusive = document.querySelector('.cmp-accordion');
    const accordionExclusiveObject = JSON.parse(accordionExclusive.getAttribute('data-options'));
    const accordionExclusiveValue = accordionExclusiveObject.exclusive;

    if (accordionExclusiveValue) {
      const detailsAll = document.querySelectorAll('details');

      detailsAll.forEach( details => {
        if (details.open) {
          details.setAttribute('aria-disabled', 'true');
        }

        details.addEventListener('toggle', (event) => {
          if (details.open) {
            details.setAttribute('aria-disabled', 'true');
          } else {
            details.removeAttribute('aria-disabled');
          }
        });
      });
    }

  }
};

export default AccordionComponent;
